import React from 'react'
import {Breadcrumb} from 'antd'
import UPM from '../../constants/urlPermissionMappings'
import {inject, observer} from 'mobx-react'
import {withTranslation} from 'react-i18next'
import {withRouter} from 'react-router-dom'
import {HomeOutlined} from '@ant-design/icons'
import {toJS} from 'mobx'

@inject('accountStore', 'reportManagementStore')
@observer
class AppBreadcrumb extends React.Component {
  state = {
    breadData: [],
    breadcrumbMap: {}
  }

  componentDidMount() {
    this.getBreadcrumbItems()
  }

  getBreadcrumbItems = () => {
    const {breadcrumbMap} = this.state
    UPM.forEach(item => {
      breadcrumbMap[item.pKey] = item.pKey
    })
  }

  convertReportName = item => {
    const {reportManagementStore, t} = this.props
    const {reportMenus} = reportManagementStore

    if (typeof (+item) === 'number' && !isNaN(+item)) {
      return reportMenus.find(findItem => findItem.id === +item).name
    } else {
      return t(`menu.${item?.replace(item[0], item[0])}`)
    }
  }

  render() {
    const {pathname, accountStore, t, reportManagementStore, match} = this.props
    const {breadcrumbMap} = this.state
    const {menuBread} = accountStore
    const {reportMenus} = reportManagementStore

    // 优先从URL参数获取reportId
    let reportId = null;
    let reportType = null;
    if (match && match.params && match.params.id) {
      reportId = match.params.id;
      if (window.location.pathname.includes('pbiReportPage')) {
        reportType = 'pbiReportPage';
      } else {
        reportType = 'reportPage';
      }
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem')
      if (selectedItem) {
        const reportPageInfo = selectedItem?.split(',')
        reportId = reportPageInfo[0];
        reportType = reportPageInfo[1];
      }
    }

    const itemName = reportMenus?.find(a=>a?.id===parseInt(reportId))?.name
    return (
      <Breadcrumb>
        {
          pathname !== '/' ?
            <Breadcrumb.Item key="Home" href="/home"><HomeOutlined/> {t(`menu.home`)}</Breadcrumb.Item> : null
        }
        {
          menuBread.slice(menuBread.length-1).map(item => {
              return (
                <Breadcrumb.Item key={item} href={(reportType !== 'reportPage'||reportType !== 'pbiReportPage') && item.toString()}>
                  {pathname.includes('smsManagementDetails') ? t(`menu.SmsManagementDetails`) :
                    reportType === 'reportPage'||reportType === 'pbiReportPage'
                      ? itemName
                      : breadcrumbMap[`${item}`] === 'home'
                        ? <><HomeOutlined/> {t(`menu.home`)}</>
                        : breadcrumbMap[`${item}`]
                          ? t(`menu.${breadcrumbMap[`${item}`]}`)
                          : this.convertReportName(item)
                  }
                </Breadcrumb.Item>
              )
            }
          )
        }
      </Breadcrumb>
    )
  }
}

export default withRouter(withTranslation()(AppBreadcrumb))
